import { alphabeticalCompare } from 'shared'
import { CIMSSingleColumn } from 'components/CIMSTable/CIMSColumn/types'
import { IdentifiedFieldIssue } from '../../../IFITrackerContext/types'
import { HelpMessage } from 'utils/constants'

export function useReportReviewStatus(): CIMSSingleColumn<IdentifiedFieldIssue> {
  return {
    title: 'Report Review Status',
    render: ({ reportReviewStatus }) => reportReviewStatus,
    width: 225,
    help: HelpMessage.IdentifiedFieldIssues.IFITracker.ReviewStatus,
    sort: {
      with: 'callback',
      onCompare: (a, b) =>
        alphabeticalCompare(a.reportReviewStatus, b.reportReviewStatus),
    },
    filter: {
      type: 'default',
      with: 'callback',
      items: (records) =>
        records.reduce((items, { reportReviewStatus }) => {
          if (reportReviewStatus) items.push(reportReviewStatus)
          return items
        }, Array<string>()),
      onFilter: (value, { reportReviewStatus }) => value === reportReviewStatus,
    },
  }
}
